import { Gender } from '@dokucoach/common-types';
import Collapse from '@material-ui/core/Collapse';
import absentIcon from 'assets/icon/signout.svg';
import routePaths from 'constants/route-paths';
import React, { MouseEvent, useLayoutEffect, useRef } from 'react';
import { Image } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import { useHistory } from 'react-router';
import { matchPath, useLocation } from 'react-router-dom';
import { AvatarImageType, getAvatarImage } from 'utils/getAvatarImage';
import { getPath } from 'utils/path';
import { BoxSubmenu, EntityListButton } from '../../style';
import DataFromSelection from '../DataFormSelection';

type Props = {
  label: string;
  id: string;
  description: string;
  gender: Gender;
  warning: number;
  parentIndex: number;
  tabPaneRef: any;
  allResidentsGroupId?: string;
  isAbsent?: boolean;
  avatarImage?: { svg: AvatarImageType } | { url: string };
};

const ResidentList = ({
  label,
  description,
  gender,
  warning,
  id,
  parentIndex,
  tabPaneRef,
  allResidentsGroupId,
  isAbsent = false,
  avatarImage = { svg: AvatarImageType.DEFAULT },
}: Props) => {
  const history = useHistory();
  const location = useLocation();

  const residentPaths = matchPath(location.pathname, {
    path: routePaths.GROUP + routePaths.RESIDENT,
  }) as { params: { residentId: string } };

  const groupPaths = matchPath(location.pathname, {
    path: routePaths.GROUP,
  }) as { params: { groupId: string } };

  const params = {
    residentId: residentPaths?.params?.residentId,
    groupId: groupPaths?.params?.groupId,
  } as { groupId: string; residentId: string };

  const isActive = params?.residentId === id;

  const currentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (currentRef && currentRef.current && isActive) {
      setTimeout(() => {
        const primaryMenuY = currentRef.current ? currentRef.current?.offsetTop : 0;
        let offsetPerMenu = 30;
        if (parentIndex + 1 > 1) {
          offsetPerMenu = 53 * (parentIndex + 1);
        }
        tabPaneRef.current.scrollTo(0, primaryMenuY + offsetPerMenu);
      }, 500);
    }
  }, [isActive, tabPaneRef, parentIndex]);

  const onClick = (e: MouseEvent<HTMLDivElement>) => {
    history.push(
      getPath([routePaths.GROUP, routePaths.RESIDENT], {
        groupId: allResidentsGroupId ?? params.groupId,
        residentId: id,
      }),
    );
    e.stopPropagation();
    return;
  };

  return (
    <li
      id={id}
      className={`menu-item menu-item-submenu ${isActive && 'menu-item-active menu-item-open'}`}
      data-menu-toggle="hover"
      style={{
        paddingLeft: '12px',
      }}
    >
      <EntityListButton
        className="menu-link my-1 menu-toggle"
        style={{
          paddingTop: '5px',
          paddingBottom: '5px',
          paddingLeft: '30px',
        }}
        onClick={onClick}
        ref={currentRef}
      >
        {gender && (
          <span className="svg-icon menu-icon m-2">
            <Image
              src={
                ('url' in avatarImage && avatarImage.url) ||
                ('svg' in avatarImage && getAvatarImage(gender, avatarImage.svg)) ||
                undefined
              }
              width="35"
              rounded
            />
          </span>
        )}
        <span className="menu-text">
          <div className={`header header-active`}>{label}</div>
          <div className="sub-header">{description}</div>
        </span>
        {isAbsent && (
          <span>
            <SVG src={absentIcon} />
          </span>
        )}
      </EntityListButton>

      <Collapse in={isActive} timeout={500}>
        <BoxSubmenu>
          <div className="menu-submenu has-collapse">
            <ul className="menu-subnav">
              <DataFromSelection />
            </ul>
          </div>
        </BoxSubmenu>
      </Collapse>
    </li>
  );
};

export default ResidentList;
